// @import
import Alpine from "alpinejs";

Alpine.directive("button", (element, {}, { cleanup }) => {
  function ensureEventTargetIsHTMLElement(e: MouseEvent): e is MouseEvent & { target: HTMLElement } {
    return e.target instanceof HTMLElement;
  }

  function handleMouseEnter(e: MouseEvent) {
    if (!ensureEventTargetIsHTMLElement(e)) return;
    const offsetXPolyfill = e.offsetX;
    const offsetYPolyfill = e.offsetY;
    const XPercent = offsetXPolyfill / e.target.clientWidth;
    const YPercent = offsetYPolyfill / e.target.clientHeight;
    e.target.style.setProperty("--animation-origin-x", `${XPercent * 100}%`);
    e.target.style.setProperty("--animation-origin-y", `${YPercent * 100}%`);
  }

  function handleMouseLeave(e: MouseEvent) {
    if (!ensureEventTargetIsHTMLElement(e)) return;

    const offsetXPolyfill = e.offsetX;
    const offsetYPolyfill = e.offsetY;
    const XPercent = offsetXPolyfill / e.target.clientWidth;
    const YPercent = offsetYPolyfill / e.target.clientHeight;
    e.target.style.setProperty("--animation-origin-x", `${XPercent * 100}%`);
    e.target.style.setProperty("--animation-origin-y", `${YPercent * 100}%`);
  }

  element.addEventListener("mouseenter", handleMouseEnter);
  element.addEventListener("mouseleave", handleMouseLeave);

  cleanup(() => {
    element.removeEventListener("mouseenter", handleMouseEnter);
    element.removeEventListener("mouseleave", handleMouseLeave);
  });
});
